import React, { useState, useRef } from 'react';
import { Container, Card, Form, Button, Stack, Table, Spinner } from 'react-bootstrap';
import { useReactToPrint } from 'react-to-print';
import * as XLSX from 'xlsx';
import axiosInstance from '../../../axiosConfig';
import Bottom from '../../Layouts/Bottom/Bottom';

const LaporanRekapDyeing = () => {
  document.title = "Laporan Rekap Dyeing";
  
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  
  const [params, setParams] = useState({
    bulan_wo: '',
    tahun_wo: new Date().getFullYear().toString(),
  });

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    documentTitle: "Laporan Rekap Dyeing",
    pageStyle: `
      @media print {
        @page {
          size: landscape;
          margin: 10mm;
        }
        body {
          background: white !important;
          color: black !important;
          font-family: Arial, sans-serif;
          font-size: 8px !important;
        }
        table {
          width: 100% !important;
          border-collapse: collapse;
          page-break-inside: auto;
        }
        tr {
          page-break-inside: avoid;
          page-break-after: auto;
        }
        thead {
          display: table-header-group;
        }
        th, td {
          border: 1px solid black !important;
          padding: 3px !important;
          background-color: transparent !important;
          color: black !important;
          font-size: 8px !important;
          white-space: normal !important;
        }
        .text-primary, div.text-primary {
          color: black !important;
        }
      }
    `
  });

  const fetchDataIndex = async () => {
    setIsLoading(true);
    try {
      const response = await axiosInstance.get(`kartu-proses-dyeing/rekap-dyeing`, { params });
      const responseData = response?.data?.data;
      
      setData(Array.isArray(responseData) ? responseData : []);
      console.log('Data fetched successfully:', responseData);

    } catch (error) {
      console.error('Gagal mengambil data:', error?.response?.data || error.message);
      alert(error?.response?.data?.message || 'Terjadi kesalahan saat mengambil data dari server.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setParams((prevParams) => ({
      ...prevParams,
      [name]: value,
    }));
  };

  // Helper untuk menampilkan format defect (misal: 199 (42,43,45,78,88))
  const renderDefectCell = (gradeData) => {
    if (!gradeData || gradeData.total_defect === undefined || gradeData.total_defect === 0 || gradeData.total_defect === '-') {
      return '-';
    }
    if (gradeData.kode_defect && gradeData.kode_defect !== '-' && gradeData.kode_defect !== '') {
      return `${gradeData.total_defect} (${gradeData.kode_defect})`;
    }
    return gradeData.total_defect;
  };

  const handleExportExcel = () => {
    if (!Array.isArray(data) || data.length === 0) {
      alert('Tidak ada data untuk diexport!');
      return;
    }

    const excelData = data.map((row, index) => ({
      "No": index + 1,
      "Tgl Masuk DO": row.tgl_masuk_do || '',
      "DO": row.no_do || '',
      "Y/M DO": row.unit_do || '',
      "Motif Greige": row.motif_greige || '',
      "Artikel": row.artikel || '',
      "Warna": row.warna || '',
      "Qty Order": row.qty_order || '',
      "Finish": row.qty_finish ?? '',
      "Y/M Finish": row.unit_finish || '',
      "Tgl Kartu": row.tgl_kartu || '',
      "No Kartu": row.no_kartu || '',
      "Batch": row.batch || '',
      "Grey": row.grey ?? '',
      "WJL/TSD/KL": row.wjl_tsd_kl || '',
      "Counter Stenter": row.counter_tenter || '',
      "Tgl Inspect": row.tgl_inspect || '',
      "No Mesin": row.no_mesin || '',
      "Operator": row.operator || '',
      "Grade A Panjang": row.grading?.grade_a?.panjang ?? '',
      "Grade A Defect": renderDefectCell(row.grading?.grade_a),
      "Grade A+ Panjang": row.grading?.grade_a_plus?.panjang ?? '',
      "Grade A+ Defect": renderDefectCell(row.grading?.grade_a_plus),
      "Grade A* Panjang": row.grading?.grade_a_asterisk?.panjang ?? '',
      "Grade A* Defect": renderDefectCell(row.grading?.grade_a_asterisk),
      "Grade B Panjang": row.grading?.grade_b?.panjang ?? '',
      "Grade B Defect": renderDefectCell(row.grading?.grade_b),
      "Grade C Panjang": row.grading?.grade_c?.panjang ?? '',
      "Grade C Defect": renderDefectCell(row.grading?.grade_c),
      "Grade PK Panjang": row.grading?.grade_pk?.panjang ?? '',
      "Grade PK Defect": renderDefectCell(row.grading?.grade_pk),
      "Grade Sample Panjang": row.grading?.grade_sample?.panjang ?? '',
      "Grade Sample Defect": renderDefectCell(row.grading?.grade_sample),
      "Grade Other Panjang": row.grading?.grade_other?.panjang ?? '',
      "Grade Other Defect": renderDefectCell(row.grading?.grade_other),
      "Total Yard": row.grading?.total_yard ?? '',
      "Pass (%)": row.grading?.persen_pass !== undefined ? row.grading.persen_pass : '',
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Laporan Rekap Dyeing");

    const namaBulan = ["", "Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
    const bulanStr = namaBulan[parseInt(params.bulan_wo)] || params.bulan_wo;

    XLSX.writeFile(workbook, `Laporan_Rekap_Dyeing_${bulanStr}_${params.tahun_wo}.xlsx`);
  };

  const pinkBgStyle = { backgroundColor: '#ffe6e6' };
  const blueBgStyle = { backgroundColor: '#e6f0ff' };
  const greenBgStyle = { backgroundColor: '#e6ffe6' };

  return (
    <>
      <div className="vh-100" style={{ position: "relative", height: "30rem" }}>
        <div
          style={{ height: "70%", justifyContent: "center" }}
          className="bg-burgundy-gradient bg-pattern-container text-white p-4 curved-container"
        ></div>

        <div className="p-4" style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, zIndex: 1 }}>
          <Container fluid className="py-5 container-padding-bottom">
            <Stack direction="vertical" gap={3} style={{ marginBottom: "200px" }}>
              <div className='py-4'>
                <h1 className='text-white'>Laporan Rekap Dyeing</h1>
                
                <div className="mt-4 d-flex justify-content-between align-items-end w-100">
                  <Form className="d-flex gap-2 w-75 align-items-end">
                    <Form.Group controlId="bulan_wo" className='flex-grow-1'>
                      <Form.Label className="text-white">Bulan</Form.Label>
                      <Form.Select 
                        name="bulan_wo" 
                        value={params.bulan_wo} 
                        onChange={handleChange}
                      >
                        <option value="">Pilih Bulan</option>
                        <option value="1">Januari</option>
                        <option value="2">Februari</option>
                        <option value="3">Maret</option>
                        <option value="4">April</option>
                        <option value="5">Mei</option>
                        <option value="6">Juni</option>
                        <option value="7">Juli</option>
                        <option value="8">Agustus</option>
                        <option value="9">September</option>
                        <option value="10">Oktober</option>
                        <option value="11">November</option>
                        <option value="12">Desember</option>
                      </Form.Select>
                    </Form.Group>

                    <Form.Group controlId="tahun_wo" className='flex-grow-1'>
                      <Form.Label className="text-white">Tahun</Form.Label>
                      <Form.Control 
                        type="number" 
                        name="tahun_wo" 
                        placeholder="Contoh: 2026"
                        value={params.tahun_wo} 
                        onChange={handleChange}
                      />
                    </Form.Group>

                    <Button variant="burgundy" className='mt-auto' onClick={fetchDataIndex} disabled={isLoading}>
                      {isLoading ? <><Spinner animation="border" size="sm" /> Tunggu sebentar</> : 'Cari'}
                    </Button>
                  </Form>

                  <div className="d-flex gap-2">
                    <Button variant="success" className="d-flex align-items-center gap-2" onClick={handleExportExcel}>
                      Export Excel
                    </Button>
                    <Button variant="light" className="d-flex align-items-center gap-2" onClick={handlePrint}>
                      Print / Cetak
                    </Button>
                  </div>
                </div>
              </div>

              <Card>
                <Card.Body>
                  <div style={{ maxHeight: '600px', overflowX: 'auto', overflowY: 'auto', position: 'relative' }}>
                    <div ref={componentRef}>
                      <h3 className='text-center d-none d-print-block'>Laporan Rekap Dyeing</h3>
                      <Table className="text-center mt-3 mb-0" bordered hover striped style={{ minWidth: '1600px' }}>
                        <thead style={{ position: 'sticky', top: 0, zIndex: 3 }}>
                          <tr>
                            <th className='p-4 align-middle' rowSpan={2} style={blueBgStyle}>Tgl Masuk DO</th>
                            <th className='p-4 align-middle' rowSpan={2} style={blueBgStyle}>DO</th>
                            <th className='p-4 align-middle' rowSpan={2} style={blueBgStyle}>Y/M</th>
                            <th className='p-4 align-middle' rowSpan={2} style={blueBgStyle}>MOTIF GREIGE</th>
                            <th className='p-4 align-middle' rowSpan={2} style={blueBgStyle}>ARTIKEL</th>
                            <th className='p-4 align-middle' rowSpan={2} style={blueBgStyle}>WARNA</th>
                            <th className='p-4 align-middle' rowSpan={2} style={blueBgStyle}>QTY ORDER</th>
                            <th className='p-4 align-middle' rowSpan={2} style={blueBgStyle}>FINISH</th>
                            <th className='p-4 align-middle' rowSpan={2} style={blueBgStyle}>Y/M</th>
                            
                            <th className='p-4 align-middle' rowSpan={2} style={pinkBgStyle}>TGL KARTU</th>
                            <th className='p-4 align-middle' rowSpan={2} style={pinkBgStyle}>NO KARTU</th>
                            <th className='p-4 align-middle' rowSpan={2} style={pinkBgStyle}>BATCH</th>
                            <th className='p-4 align-middle' rowSpan={2} style={pinkBgStyle}>GREY</th>
                            <th className='p-4 align-middle text-primary' rowSpan={2} style={pinkBgStyle}>WJL/TSD/KL</th>
                            <th className='p-4 align-middle' rowSpan={2} style={pinkBgStyle}>COUNTER STENTER</th>
                            <th className='p-4 align-middle' rowSpan={2} style={pinkBgStyle}>TGL INSPECT</th>
                            <th className='p-4 align-middle' rowSpan={2} style={pinkBgStyle}>NO MESIN</th>
                            <th className='p-4 align-middle' rowSpan={2} style={pinkBgStyle}>OPERATOR</th>

                            <th className='p-4 align-middle' colSpan={2} style={greenBgStyle}>GRADE A</th>
                            <th className='p-4 align-middle' colSpan={2} style={greenBgStyle}>GRADE A+</th>
                            <th className='p-4 align-middle' colSpan={2} style={greenBgStyle}>GRADE A*</th>
                            <th className='p-4 align-middle' colSpan={2} style={greenBgStyle}>GRADE B</th>
                            <th className='p-4 align-middle' colSpan={2} style={greenBgStyle}>GRADE C</th>
                            <th className='p-4 align-middle' colSpan={2} style={greenBgStyle}>GRADE PK</th>
                            <th className='p-4 align-middle' colSpan={2} style={greenBgStyle}>GRADE SAMPLE</th>
                            <th className='p-4 align-middle' colSpan={2} style={greenBgStyle}>GRADE OTHER</th>
                            
                            <th className='p-4 align-middle' rowSpan={2} style={greenBgStyle}>TOTAL YARD</th>
                            <th className='p-4 align-middle' rowSpan={2} style={greenBgStyle}>PASS (%)</th>
                          </tr>
                          <tr>
                            <th style={greenBgStyle}>Panjang</th>
                            <th style={greenBgStyle}>Defect</th>
                            <th style={greenBgStyle}>Panjang</th>
                            <th style={greenBgStyle}>Defect</th>
                            <th style={greenBgStyle}>Panjang</th>
                            <th style={greenBgStyle}>Defect</th>
                            <th style={greenBgStyle}>Panjang</th>
                            <th style={greenBgStyle}>Defect</th>
                            <th style={greenBgStyle}>Panjang</th>
                            <th style={greenBgStyle}>Defect</th>
                            <th style={greenBgStyle}>Panjang</th>
                            <th style={greenBgStyle}>Defect</th>
                            <th style={greenBgStyle}>Panjang</th>
                            <th style={greenBgStyle}>Defect</th>
                            <th style={greenBgStyle}>Panjang</th>
                            <th style={greenBgStyle}>Defect</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.length > 0 ? (  
                            data.map((row, index) => (
                              <tr key={row.id || index}>
                                <td>{row.tgl_masuk_do || '-'}</td>
                                <td>{row.no_do || '-'}</td>
                                <td>{row.unit_do || '-'}</td>
                                <td>{row.motif_greige || '-'}</td>
                                <td>{row.artikel || '-'}</td>
                                <td>{row.warna || '-'}</td>
                                <td>{row.qty_order || '-'}</td>
                                <td>{row.qty_finish ?? '-'}</td>
                                <td>{row.unit_finish || '-'}</td>

                                <td style={pinkBgStyle}>{row.tgl_kartu || '-'}</td>
                                <td style={pinkBgStyle}>{row.no_kartu || '-'}</td>
                                <td style={pinkBgStyle}>{row.batch || '-'}</td>
                                <td style={pinkBgStyle}>{row.grey ?? '-'}</td>
                                <td style={pinkBgStyle} className='text-primary'>{row.wjl_tsd_kl || '-'}</td>
                                <td style={pinkBgStyle}>{row.counter_tenter || '-'}</td>
                                <td style={pinkBgStyle}>{row.tgl_inspect || '-'}</td>
                                <td style={pinkBgStyle}>{row.no_mesin || '-'}</td>
                                <td style={pinkBgStyle}>{row.operator || '-'}</td>

                                <td style={greenBgStyle}>{row.grading?.grade_a?.panjang ?? '-'}</td>
                                <td style={greenBgStyle}>{renderDefectCell(row.grading?.grade_a)}</td>

                                <td style={greenBgStyle}>{row.grading?.grade_a_plus?.panjang ?? '-'}</td>
                                <td style={greenBgStyle}>{renderDefectCell(row.grading?.grade_a_plus)}</td>

                                <td style={greenBgStyle}>{row.grading?.grade_a_asterisk?.panjang ?? '-'}</td>
                                <td style={greenBgStyle}>{renderDefectCell(row.grading?.grade_a_asterisk)}</td>

                                <td style={greenBgStyle}>{row.grading?.grade_b?.panjang ?? '-'}</td>
                                <td style={greenBgStyle}>{renderDefectCell(row.grading?.grade_b)}</td>

                                <td style={greenBgStyle}>{row.grading?.grade_c?.panjang ?? '-'}</td>
                                <td style={greenBgStyle}>{renderDefectCell(row.grading?.grade_c)}</td>

                                <td style={greenBgStyle}>{row.grading?.grade_pk?.panjang ?? '-'}</td>
                                <td style={greenBgStyle}>{renderDefectCell(row.grading?.grade_pk)}</td>

                                <td style={greenBgStyle}>{row.grading?.grade_sample?.panjang ?? '-'}</td>
                                <td style={greenBgStyle}>{renderDefectCell(row.grading?.grade_sample)}</td>

                                <td style={greenBgStyle}>{row.grading?.grade_other?.panjang ?? '-'}</td>
                                <td style={greenBgStyle}>{renderDefectCell(row.grading?.grade_other)}</td>

                                <td style={greenBgStyle}>{row.grading?.total_yard ?? '-'}</td>
                                <td style={greenBgStyle}>{row.grading?.persen_pass !== undefined ? `${row.grading.persen_pass}%` : '-'}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="36" className="text-center py-4">Tidak ada data ditemukan</td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </Card.Body>
              </Card>

            </Stack>
          </Container>
        </div>
      </div>
      <Bottom />
    </>
  );
};

export default LaporanRekapDyeing;